<template>
  <NxInput
    name="municipio"
    type="text"
    label="Municipio:"
    placeholder="EX: Pederneiras"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputMunicipio',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputMunicipio.vue